<script>
import { getSysConfigInfo } from "@/api/home";
import { pageSortRender } from "../minin/homepage.js";
import LeftNav from "../controler/LeftNav.vue";
import { mapState } from "vuex";
export default {
  components: {
    LeftNav
  },
  data() {
    return {
      configs: [],
      fandedFirstBanner: false
    };
  },
  computed: {
    ...mapState("user", {
      userInfo: state => {
        return state.userInfo;
      }
    })
  },
  methods: {
    async getConfigs() {
      let res = await getSysConfigInfo();
      this.fandedFirstBanner = false;
      this.fandFirstBanner(res.modules);
      this.$set(this, "configs", res.modules || []);
      console.log("configs", this.configs);
    },
    //递归查找第一个轮播图，只有第一个轮播图才显示右侧个人信息
    fandFirstBanner(list) {
      if (this.fandedFirstBanner) {
        return;
      }
      for (let i = 0; i < list.length; i++) {
        const item = list[i];
        if (item.moduleName === "广告图片" && !this.fandedFirstBanner) {
          this.fandedFirstBanner = true;
          item.showUserInfo = true;
          return;
        }
        if (item.children && item.children.length > 0) {
          this.fandFirstBanner(item.children);
        }
      }
    }
  },
  created() {
    this.getConfigs();
  },
  render(h) {
    return (
      <div>
        <LeftNav></LeftNav>
        {h("div", pageSortRender(h, this.configs, this.userInfo))}
      </div>
    );
  }
};
</script>
<style lang="scss">
.model-title {
  font-size: 16px;
  color: #000;
  font-weight: 500;
  position: relative;
  margin-left: 8px;
  &::before {
    display: block;
    content: "";
    position: absolute;
    left: -8px;
    top: 0;
    height: 100%;
    width: 4px;
    background-color: var(--color-primary);
  }
}
.lookMore {
  cursor: pointer;
  font-size: 14px;
  color: #8a8a8a;
  font-weight: 500;
}
</style>
